import React, { useState, useEffect } from 'react';
import { 
  Modal, 
  Button, 
  TextField, 
  Grid, 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  FormControlLabel, 
  Checkbox 
} from '@mui/material';
import { useUser } from '../contexts/UserContext';

function CondicionModal({ open, handleClose, tiposCondicion, handleSave, editingCondicion, isEditing, onSave }) {
  const server = process.env.REACT_APP_API_ROUTE;
  const [tipoCondicion, setTipoCondicion] = useState(null);
  const [nombreCondicion, setNombreCondicion] = useState('');
  // Nuevo estado para el checkbox "Mostrar en Resultado"
  const [mostrarEnResultado, setMostrarEnResultado] = useState(false);
  const { user } = useUser();

  // useEffect para cargar datos cuando se edita una condición
  useEffect(() => {
    if (isEditing && editingCondicion) {
      console.log('Editando condición:', editingCondicion); // Debug
      setTipoCondicion(editingCondicion.id_tipocondicion ?? null);
      setNombreCondicion(editingCondicion.descripcionCondicion || '');
      setMostrarEnResultado(editingCondicion.mostrarEnResultado || false);
    } else if (open && !isEditing) {
      // Limpiar campos cuando se abre para crear nueva condición
      setTipoCondicion(null);
      setNombreCondicion('');
      setMostrarEnResultado(false);
    }
  }, [isEditing, editingCondicion, open]);

  const handleGuardar = async () => {
    const condicionData = {
      id_tipocondicion: tipoCondicion,
      descripcionCondicion: nombreCondicion,
      mostrarEnResultado: mostrarEnResultado,
    };

    if (isEditing) {
      // Si estamos editando, agregamos el ID y modificadoPor
      condicionData.idCondicion = editingCondicion.idCondicion;
      condicionData.modificadoPor = user.codigoUsuario;
    } else {
      // Si es nuevo, usamos ingresadoPor
      condicionData.ingresadoPor = user.codigoUsuario;
    }

    console.log(condicionData);
    
    if (handleSave) {
      // Usar la función handleSave pasada como prop
      await handleSave(condicionData);
      
      // Llamar onSave para refrescar los datos si está disponible
      if (onSave) {
        await onSave();
      }
    } else {
      // Comportamiento original si no se pasa handleSave
      try {
        const response = await fetch(`${server}/CdmCondicionesEspeciales`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(condicionData),
        });

        if (response.ok) {
          const data = await response.json();
          alert('Condición guardada correctamente');
          console.log('Datos guardados:', data);
        } else {
          alert('Error al guardar la condición');
          console.error('Error al guardar la condición:', response.statusText);
        }
      } catch (error) {
        alert('Error al conectarse con el servidor');
        console.error('Error en la solicitud POST:', error);
      }
    }

    // Limpiar campos y cerrar modal
    setTipoCondicion(null);
    setNombreCondicion('');
    setMostrarEnResultado(false);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div style={{ padding: '20px', background: 'white', margin: '50px auto', maxWidth: '500px' }}>
        <h2>{isEditing ? 'Editar Condición o Requisito' : 'Agregar Condición o Requisito'}</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Tipo de Condición</InputLabel>
              <Select
                value={tipoCondicion}
                onChange={(e) => setTipoCondicion(e.target.value)}
              >
                {tiposCondicion.map((tipo) => (
                  <MenuItem key={tipo.id} value={tipo.id}>
                    {tipo.tipoCondicion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Condición o Requisito"
              value={nombreCondicion}
              onChange={(e) => setNombreCondicion(e.target.value)}
            />
          </Grid>
          {/* Nuevo campo checkbox */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={mostrarEnResultado}
                  onChange={(e) => setMostrarEnResultado(e.target.checked)}
                />
              }
              label="Mostrar en Resultado"
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button onClick={handleGuardar} variant="contained" color="primary">
              Guardar
            </Button>
            <Button onClick={handleClose} variant="outlined" color="secondary" style={{ marginLeft: '10px' }}>
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

export default CondicionModal;
